import columnMenu from './column-menu'
import dataTable from './data-table'
import generateXlsxFile from './generate-xlsx-file'
import summary from './summary'

export default {
    button: {
        goBack: 'Back to overview'
    },

    tooltip: {
        columnMenu: 'Adjust table',
        resetFilters: 'Reset filter selection',
        downloadExcel: 'Excel download'
    },
    search: 'Search',

    columnMenu,
    dataTable,
    generateXlsxFile,
    summary
}
